import React, { useState } from "react"
import { IoCloseOutline } from "react-icons/io5"

import Modal from "@fuse/sharedComponents/modal/Modal"

import { logAnalyticEvent } from "@firebaseConfig/analyticsUtil"

import VideoPreviewIcon from "@fuse/assets/images/video-preview.svg"
import videoPreview from "@fuse/assets/video/videoPreview.mp4"

import ExclusivePreview from "./ExclusivePreview"

interface VideoPreviewProps {
  className?: string
  onClose?: () => void
}

const VideoPreview: React.FC<VideoPreviewProps> = ({
  className = "",
  onClose = () => {},
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClose = () => {
    logAnalyticEvent("video_preview_close", {
      component: "VideoPreview",
      action: "close_click",
    })
    onClose?.()
  }

  const handleAddIntro = () => {
    logAnalyticEvent("video_preview_add_intro", {
      component: "VideoPreview",
      action: "add_intro_click",
    })
    setIsModalOpen(true)
  }

  return (
    <>
      <div className={`video-preview p-4 bg-transparent ${className || ""}`}>
        <div className="relative">
          <div className="flex items-center gap-2">
            <img src={VideoPreviewIcon} alt="video preview icons" />
            <div>
              <div className="text-white/50 text-base">Video intro</div>
            </div>
            <div className="ml-auto">
              <IoCloseOutline
                className="cursor-pointer"
                onClick={handleClose}
                color="#C2C2C2"
                size={20}
              />
            </div>
          </div>
          <div className="text-white text-base mt-4 text-left">
            <video muted playsInline className="w-full h-full" loop autoPlay>
              <source src={videoPreview} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="text-white text-base mt-4 text-left">
            Enchant your guests with a custom intro video. <br />
            Elevate your event and set the vibe.
          </div>
          <hr className="w-full border-white/30 my-4" />

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="text-white text-base flex items-center">
                <span className="line-through text-gray-400 mr-2">
                  $2/invite
                </span>
                <span className="text-white font-medium">$1/invite</span>
                <span className="ml-2 bg-white/10 text-white text-[12px] px-1 rounded">
                  50% OFF
                </span>
              </div>
            </div>

            <button
              type="button"
              onClick={handleAddIntro}
              className="w-full bg-white/10 text-white py-3 px-4 rounded-lg transition-colors"
            >
              Add intro
            </button>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        modalClass="bg-black/80"
      >
        <ExclusivePreview />
      </Modal>
    </>
  )
}

export default VideoPreview
